/** Align with BackofficeService PriceAgreementValidator MAX_LENGTH_AGREEMENT_FILES (MDB-219). */
export const MEMBER_PRICE_AGREEMENT_MAX_FILES = 50;
